"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProperties = getProperties;
const utils_1 = require("@aws-amplify/core/internals/utils");
const getProperties_1 = require("./internal/getProperties");
// Overload signatures above are the public contract; the impl is intentionally untyped and shape is enforced by resolveCtxArgs.
function getProperties(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    return (0, getProperties_1.getProperties)(ctx, input);
}
